<groundworks-modal>
  <groundworks-modal-header [title]="title()" [isCancellable]="true" (cancelModal)="cancel()" />
  <groundworks-modal-body>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mb-2">
        <label for="payment-type">Payment Type</label>
        <select id="payment-type" class="form-select" formControlName="type">
          <option [ngValue]="null">Select a type</option>
          @for (type of paymentTypes; track type) {
            <option [ngValue]="type">{{ typeLabels[type] }}</option>
          }
        </select>
      </div>
      @if (showDirection()) {
        <div class="mb-2">
          <span class="d-block">Direction</span>
          <label class="me-3">
            <input type="radio" name="sign" formControlName="sign" value="positive" />
            Increase (+)
          </label>
          <label>
            <input type="radio" name="sign" formControlName="sign" value="negative" />
            Decrease (&minus;)
          </label>
        </div>
      }
      <div class="mb-2">
        <label for="payment-magnitude">Amount</label>
        <input
          #amountInput
          id="payment-magnitude"
          type="number"
          step="0.01"
          class="form-control"
          formControlName="magnitude"
          (blur)="formatAmount()"
        />
      </div>
      <div class="mb-2">
        <label for="payment-percent-of-commission">% of Commission</label>
        <input
          id="payment-percent-of-commission"
          type="number"
          step="any"
          class="form-control"
          formControlName="percentOfCommission"
        />
      </div>
      <!-- ONE date field only. The control key stays `qualificationDate` (the wire/DB property name);
           only the visible label reads "Date Qualified". The retired `payDate` control is dual-written
           from this value at submit — see buildPaymentDto(). -->
      <div class="mb-2">
        <label for="payment-qualification-date">Date Qualified</label>
        <input id="payment-qualification-date" type="date" class="form-control" formControlName="qualificationDate" />
      </div>
      <div class="mb-2">
        <label for="payment-notes">Notes</label>
        <textarea id="payment-notes" class="form-control" formControlName="notes"></textarea>
      </div>

      <dl class="row mb-2">
        <dt class="col-6">Resulting Signed Amount</dt>
        <dd class="col-6">{{ resultAmount() ?? '—' }}</dd>
        <dt class="col-6">Net Paid After This Payment</dt>
        <dd class="col-6">{{ projectedNetPaid() ?? '—' }}</dd>
      </dl>

      @if (errorMessage()) {
        <p class="text-danger">{{ errorMessage() }}</p>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
